import * as React from 'react'
import { cn } from '@/lib/utils'

// 简易滚动容器，替代缺失的 Shadcn ScrollArea
export const ScrollArea = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('relative overflow-y-auto [&_img]:select-none', className)}
        {...props}
      >
        {children}
      </div>
    )
  }
)

ScrollArea.displayName = 'ScrollArea'

